// The frozen v2 tasks datasets are built from, and the averages estimates start from (/api/replay/pool), fetched
// once per page load and again after a dataset changes.
import { get } from '../core'
import type { Planning, Sampleable } from '../../shared/replay'

export interface PoolTask extends Sampleable { title: string }
export interface Pool { tasks: PoolTask[]; planning: Planning }

let cached: Promise<Pool> | null = null

export function loadPool(): Promise<Pool> {
  if (!cached) {
    cached = get('/api/replay/pool').then((d: any) => {
      if (!d || !Array.isArray(d.tasks)) throw new Error('no pool')
      return d as Pool
    })
    cached.catch(() => { cached = null })
  }
  return cached
}

export function forgetPool(): void { cached = null }
